import { createContext } from 'react';

import { ContextType } from '@/lib/authorization';
import { ForgotPasswordRequest } from '@/types/request/ForgotPasswordRequest';
import { LoginRequest } from '@/types/request/LoginRequest';
import { ResetPasswordRequest } from '@/types/request/ResetPasswordRequest';
import { ForgotPasswordErrorResponse } from '@/types/response/ForgotPasswordResponse';
import { LoginErrorResponse } from '@/types/response/LoginResponses';
import { ResetPasswordErrorResponse } from '@/types/response/ResetPasswordResponse';
import { UserRole } from '@/types/user/userType';

export interface AuthContextType {
    accessToken: string | null
    /** The client a Manager or Spectator is bound to (token `clientId` claim); null for SuperAdmins and Admins. */
    clientId: string | null
    context: ContextType | null
    firstName: string | null
    forgetPasswordLoading: boolean;
    forgotPassword: (data: ForgotPasswordRequest) => void;
    forgotPasswordError?: ForgotPasswordErrorResponse,
    loading: boolean;
    login: (data: LoginRequest) => void;
    loginError?: { status: number; data: LoginErrorResponse; };
    logout: () => void;
    resetForgotPasswordError: () => void;
    resetLoginUserError: () => void;
    resetPassword: (data: ResetPasswordRequest) => void;
    resetPasswordError?: { status: number; data: ResetPasswordErrorResponse; };
    resetPasswordLoading: boolean;
    resetResetPasswordError: () => void;
    role: UserRole | null
    setTenantId: (id: string) => void
    tenantId: string | null
    userId: string | null
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const TENANT_ID_STORAGE_KEY = "tenantId";
